<app-document-table
  subtitle="Gestione documenti processati"
  basePath="processed/" 
  [documents]="documents()"
  [isLoading]="isLoading()"
  [loadingMessage]="loadingMessage()"
  [hasError]="hasError()">
</app-document-table>